export const whitelabel = {
  plans: '计划',
  managePlan: '管理计划',
  whitelabelCharges: '白标费用',
  chargesOrTaxesConfiguration: '费用/税收配置',
  websitePlans: '网站计划',
  whatsappPlansHeader: 'WhatsApp计划',
  addOnPlans: {
    createAddOnPlans: '创建附加计划',
    checkoutYourCurrentMessage: '查看您当前的消息附加计划以及为您的客户添加新计划',
    choosePlanValidity: '选择计划有效期',
    chooseValidity: '选择有效期',
    oneYear: '一年',
    billingCycle: '计费周期',
    numberOfMessages: '消息数量',
    pleaseEnterNumberOfMessages: '请输入消息数量',
    setCurrency: '设置货币',
    select: '选择',
    inr: '印度卢比',
    usd: '美元',
    cad: '加元',
    clearAll: '清除所有',
    apply: '应用',
    currency: '货币',
    amount: '金额',
    validity: '有效期',
    upgradePlan: '升级计划',
    addPlan: '添加计划',
    serialNumber: '序号',
    messages: '消息',
    active: '活跃',
    priceDetails: '价格详情',
    action: '操作',
    addOnChanges: '附加费用：',
    perYear: '每年',
    taxes: '税收',
    placeholders: {
      enterNumberOfMesasges: '输入消息数量',
      enterAmount: '输入金额',
      enterValidity: '输入有效期',
      searchByMessages: '按消息搜索'
    },
    modal: {
      deleteAddOnsPlan: '删除附加计划',
      wantToDeleteThisAddOnsPlan: '您确定要删除此附加计划吗？',
    }
  },
  charges: {
    addWhitelabelCharges: '添加白标费用',
    checkoutExistingCharges: '查看不同支付方式的现有费用并添加新的白标费用',
    currency: '货币',
    chooseCurrency: '选择货币',
    amountPerBotPerMonth: '每个机器人每月金额',
    cancel: '取消',
    upgradeChanges: '更新费用',
    addCharges: '添加费用',
    serialNumber: '序号',
    action: '操作',
    taxes: '税收',
    placeholders: {
      enterAmountBotPerMonth: '输入每个月每个机器人的金额',
      searchByCurrency: '按货币搜索',
    },
    modal: {
      deleteCharges: '删除费用',
      wantToDeleteThisCharge: '您确定要删除此费用吗？',
    }
  },
  planManagement: {
    createNewPlans: '创建新计划',
    checkoutYourCurrentPlan: '查看您当前的计划并为您的客户添加新计划',
    choosePlan: '选择计划',
    selectPlan: '选择计划',
    baby: '入门版',
    king: '高级版',
    displayName: '显示名称',
    messageLimit: '消息限制',
    enterAValidEmail: '输入有效的电子邮件',
    setCurrency: '设置货币',
    select: '选择',
    inr: '印度卢比',
    usd: '美元',
    cad: '加元',
    clearAll: '清除所有',
    apply: '应用',
    perMonth: '/每月',
    perYear: '/每年',
    cancel: '取消',
    upgradePlan: '升级计划',
    addPlan: '添加计划',
    serialNumber: '序号',
    plan: '计划',
    messages: '消息',
    pricing: '定价',
    actions: '操作',
    perMonthText: '每月',
    perYearText: '每年',
    placeholders: {
      enterDisplayName: '输入显示名称',
      enterMessageLimit: '输入消息限制',
      searchByPlanName: '按计划名称或消息搜索',
    },
    modal: {
      deletePlan: '删除计划',
      wantToDeleteThisBabyPlan : '删除入门版计划将影响所有客户。您确定要删除此计划吗？',
      wantToDeleteThisPlan: '您确定要删除此计划吗？'
    },
    appTooltip: {
      chooseYourPlanType: '选择您的计划类型',
      pleaseInputYourPlanDisplayName: '请输入您的计划显示名称',
      typeMessageLimitForCustomer: '为客户输入消息限制',
      selectYourPreferredCurrencies: '选择您首选的货币',
    }
  },
  taxesConfiguration: {
    addTaxes: '添加税收',
    checkoutExistingTaxes: '查看不同支付方式和新税收的现有税收',
    taxName: '税名',
    applicableOn: '适用于',
    choosePlans: '选择计划',
    chooseCurrency: '选择货币',
    percentage: '百分比',
    cancel: '取消',
    serialNumber: '序号',
    name: '名称',
    currency: '货币',
    updateTaxes: '更新税收',
    actions: '操作',
    modal: {
      deleteTaxes: '删除税收',
      wantToDeleteThisTax: '您确定要删除此税收吗？'
    },
    placeholders: {
      taxName: '税名',
      taxPercentage: '税收百分比',
      searchByCurrency: '按货币搜索',
    }
  },
  whatsappPlans: {
    createNewPlans: '创建新计划',
    checkoutYourCurrentAndNewPlans: '查看您当前的计划并为您的客户添加新计划',
    choosePlan: '选择计划',
    selectPlan: '选择计划',
    baby: '入门版',
    king: '高级版',
    displayName: '显示名称',
    messageLimit: '对话限制',
    enterAValidMessageLimit: '输入有效的对话限制',
    setCurrency: '设置货币',
    select: '选择',
    inr: '印度卢比',
    usd: '美元',
    cad: '加元',
    clearAll: '清除所有',
    apply: '应用',
    perMonth: '/每月',
    perYear: '/每年',
    cancel: '取消',
    addPlan: '添加计划',
    serialNumber: '序号',
    plan: '计划',
    messages: '对话',
    pricing: '定价',
    actions: '操作',
    perMonthText: '每月',
    perYearText: '每年',
    updatePlan: '更新计划',
    placeholders: {
      enterDisplayName: '输入显示名称',
      enterMessageLimit: '输入对话限制',
      searchByPlanName: '按计划名称或对话搜索',
    },
    appTooltip: {
      typeMessageLimitForCustomer: '为客户输入对话限制',
      chooseYourPlanType: '选择您的计划类型',
      selectYourPreferredCurrencies: '选择您首选的货币',
      pleaseInputYourPlanDisplayName: '请输入您的计划显示名称',
    },
    modal: {
      deletePlan: '删除计划',
      areYouSureYouWantToDeleteThisPlan: '您确定要删除此计划吗？',
      wantToDeleteThisBabyPlan : '删除入门版计划将影响所有客户。您确定要删除此计划吗？'
    }
  }
};
